import { BaseHubImage } from 'basehub/next-image'
import { Button } from '~/sotano-kit/primitives/button'
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/sotano-kit/primitives/dialog'
// import jbSignature from '~/public/jb-signature.png'

import type { OnboardingStep } from '.'

export const TeamOnboardingJb: React.FC<OnboardingStep> = ({
  onSkip,
  onNextStep,
}) => (
  <>
    <DialogHeader className="pt-4 px-4 !space-y-3">
      <BaseHubImage
        src="https://assets.basehub.com/9dbc0da9/ASvIUJ2oQu4r-8ARa_Lkj/avatar-2023.png"
        width={70}
        height={70}
        className="rounded-full border border-dark-border-solid mx-auto"
        quality={100}
        alt="Julian Benega's profile picture"
      />
      <DialogTitle className="text-center">Julian Benegas, CEO</DialogTitle>
    </DialogHeader>
    <hr className="border-dark-border-solid m-4" />
    <div className="text-dark-muted leading-[1.4] px-7 pb-4">
      <DialogDescription className="text-dark-bright mb-4">
        Hey there! On behalf of the whole BaseHub Team, I wanted to thank you
        for being one of our customers.
      </DialogDescription>
      We're building BaseHub to make Content Management fast, collaborative, and
      delightful. We hope you love using it as much as we love working on it.
      <br />
      <br />
      If you have any feedback, or need a helping hand, you can reach out to me
      directly at{' '}
      <a
        href="mailto:jb@basehub.com"
        target="_blank"
        rel="noopener"
        className="underline"
      >
        jb@basehub.com
      </a>
      , or via any of our support channels. Enjoy!
      {/* <Image src={jbSignature} alt="jb's signature" /> */}
    </div>
    <DialogFooter className="border-t border-dark-border-solid px-4 py-4 sm:space-x-4 flex">
      <DialogClose asChild onClick={onSkip}>
        <Button intent="secondary" size="large" type="button">
          See My Team
        </Button>
      </DialogClose>
      <Button size="large" onClick={onNextStep}>
        Complete Setup
      </Button>
    </DialogFooter>
  </>
)
